import type { CustomerPortalClient } from "@redotech/redo-customer-portal-server/rpc/schema";
import { Context, createContext } from "react";

/**
 * Provides an authenticated RPC client to the app.
 * Will be undefined until the user is authenticated.
 */
export const RpcClientContext: Context<CustomerPortalClient | undefined> =
  createContext<CustomerPortalClient | undefined>(undefined);
